import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.23.1_next@14.2.14_@babel+core@7.25.8_@opentelemetry+api@1.9.0_react-dom@18._19e8ec98b9887996739d886cf12a60e0/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.23.1_next@14.2.14_@babel+core@7.25.8_@opentelemetry+api@1.9.0_react-dom@18._19e8ec98b9887996739d886cf12a60e0/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["MedcenterAppointment"] */ "/app/src/app/[locale]/[city]/medcenter/[alias]/ui/MedcenterAppointment.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MedcenterBottomBar"] */ "/app/src/app/[locale]/[city]/medcenter/[alias]/ui/MedcenterBottomBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MedcenterMap"] */ "/app/src/app/[locale]/[city]/medcenter/[alias]/ui/MedcenterMap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MedcenterNavbar"] */ "/app/src/app/[locale]/[city]/medcenter/[alias]/ui/MedcenterNavbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MedcenterPhonesModal"] */ "/app/src/app/[locale]/[city]/medcenter/[alias]/ui/MedcenterPhonesModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MedcenterServicesContent"] */ "/app/src/app/[locale]/[city]/medcenter/[alias]/ui/MedcenterServices/MedcenterServicesContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MedcenterTypes"] */ "/app/src/app/[locale]/[city]/medcenter/[alias]/ui/MedcenterTypes.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OurDoctors"] */ "/app/src/app/[locale]/[city]/medcenter/[alias]/ui/OurDoctors.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GTMContext"] */ "/app/src/features/Analytics/model/context/GTMContext.ts");
;
import(/* webpackMode: "eager", webpackExports: ["GTMInitializer"] */ "/app/src/features/Analytics/ui/GTMInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GTMProvider"] */ "/app/src/features/Analytics/ui/GTMProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/sprites/base.sprite.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/sprites/social.sprite.svg");
;
import(/* webpackMode: "eager", webpackExports: ["TrackEvent"] */ "/app/src/shared/lib/analytics/component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageGallery"] */ "/app/src/widgets/ImageGallery/ui/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionLinks"] */ "/app/src/widgets/MainLayout/ui/footer/SectionLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderMenu"] */ "/app/src/widgets/MainLayout/ui/header/HeaderMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderMenuButton"] */ "/app/src/widgets/MainLayout/ui/header/HeaderMenuButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderSearch"] */ "/app/src/widgets/MainLayout/ui/header/HeaderSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewsListClient"] */ "/app/src/widgets/Reviews/ui/ReviewsListClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DoctorSchedule"] */ "/app/src/widgets/Schedule/ui/DoctorSchedule.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MedcenterSchedule"] */ "/app/src/widgets/Schedule/ui/MedcenterSchedule.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TitleSection"] */ "/app/src/widgets/TitleSection/ui/index.tsx");
